import { useI18n } from 'vue-i18n'
import FetchFactory from '../factory'

interface IInterest {
  query?: {
    parent_id?: number | string
  }
}

interface IQualification {
  query?: {
    qualification_id?: number | string
  }
}

interface City {
  query: {
    province_id: number
  }
}

interface Province {
  query: {
    country_id?: number
  }
}

interface IRole {
  params: {
    jobCategory: string
  }
}

interface ISpecifiedRole {
  params: {
    jobCategory: string
    jobRole: string
  }
}

class MasterModule extends FetchFactory<any> {
    async getReferralSources() {
        return await useAsyncData('referral-sources', async () => {
            const { t } = useI18n()

            const res = await super.call('/api/referral-sources', {
                method: 'GET',
      })

            if (res.data) {
                res.data = [...res.data, { id: null, slug: 'other', name: t('Other') }]
            }
            return res
        })
    }

    async getCareerStatuses() {
        return await useAsyncData(() => {
            return super.call('/api/career-statuses', {
                method: 'GET',
      })
        })
    }

    async getIndustries() {
        return await useAsyncData(() => {
            return super.call('/api/industries', {
                method: 'GET',
      })
        })
    }

    async getInterests() {
        return await useAsyncData(() => {
            return super.call('/api/interests', {
                method: 'GET',
      })
        })
    }

    async getJobInterests() {
        return await useAsyncData(() => {
            return super.call('/api/job-interests', {
                method: 'GET',
      })
        })
    }

    async getLocations() {
        return await useAsyncData(() => {
            return super.call('/api/locations', {
                method: 'GET',
      })
        })
    }

    async getJlptLevel() {
        return await useAsyncData(() => {
            return super.call('/api/jlpt-levels', {
                method: 'GET',
      })
        })
    }

    async getJobType() {
        return await useAsyncData(() => {
            return super.call('/api/jobs/types', {
                method: 'GET',
      })
        })
    }

    async getJobStatus() {
        return await useAsyncData(() => {
            return super.call('/api/jobs/statuses', {
                method: 'GET',
      })
        })
    }

    async getCountries() {
        return await useAsyncData(() => {
            return super.call('/api/countries', {
                method: 'GET',
      })
        })
    }

    async getSkills() {
        return await useAsyncData(() => {
            return super.call('/api/skills', {
                method: 'GET',
      })
        })
    }

    async getComputerSkills() {
        return await useAsyncData('computer-skills', () => {
            return super.call('/api/skills', {
                method: 'GET',
                query: { category: 'pc' },
      })
        })
    }

    async getLanguages() {
        return await useAsyncData(() => {
            return super.call('/api/languages', {
                method: 'GET',
      })
        })
    }

    async getJobRoles(payload: IRole) {
        return await useAsyncData(() => {
            const { params } = payload
            return super.call(
                `/api/job-categories/${params.jobCategory}/job-roles`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async getSpecifiedRoles(payload: ISpecifiedRole) {
        return await useAsyncData(() => {
            const { params } = payload
            return super.call(
                `/api/job-categories/${params.jobCategory}/job-roles/${params.jobRole}/specified-roles`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async getPositionLevels() {
        return await useAsyncData(() => {
            return super.call('/api/position-levels', {
                method: 'GET',
      })
        })
    }

    async getQualifications() {
        return await useAsyncData(() => {
            return super.call('/api/qualifications', {
                method: 'GET',
      })
        })
    }

    async getFieldOfStudies(payload: IQualification) {
        return await useAsyncData(() => {
            const { query } = payload
            return super.call('/api/field-of-studies', {
                method: 'GET',
                query
            })
        })
    }

    // async getFieldOfStudies() {
    //     return await useAsyncData(() => {
    //         // const { query } = payload
    //         return super.call('/api/field-of-studies', {
    //             method: 'GET'
    //         })
    //     })
    // }
    async getSalaryRange() {
        return await useAsyncData(() => {
            return super.call('/api/salary-range', {
                method: 'GET',
      })
        })
    }

    async getPrefecture() {
        return await useAsyncData(() => {
            return super.call('/api/prefectures', {
                method: 'GET',
      })
        })
    }

    // payload: Province
    async getProvinces(payload: Province) {
        return await useAsyncData(() => {
            const { query } = payload
            return super.call('/api/provinces', {
                method: 'GET',
                query: {
                    ...query,
                    country_id: 1,
        }
            })
        })
    }

    async getJobCategories() {
        return await useAsyncData(() => {
            return super.call('/api/job-categories', {
                method: 'GET',
      })
        })
    }

    async getCategories() {
        return await useAsyncData(() => {
            return super.call('/api/categories', {
                method: 'GET',
      })
        })
    }

    async getJobInterest(payload: IInterest) {
        return await useAsyncData(() => {
            const { query } = payload
            return super.call('/api/job-interests', {
                method: 'GET',
                query
            })
        })
    }

    getJobInterestCompleteProfile(payload: IInterest) {
        const { query } = payload
        return super.call('/api/job-interests', {
            method: 'GET',
            query
        })
    }

    async getExpectedSalaryRanges() {
        return await useAsyncData(() => {
            return super.call('/api/job-expected-salary-ranges', {
                method: 'GET',
      })
        })
    }

    async getCompanySize() {
        return await useAsyncData(() => {
            return super.call('/api/company-sizes', {
                method: 'GET',
      })
        })
    }

    async getEntrySystem() {
        return await useAsyncData(() => {
            return super.call('/api/entry-systems', {
                method: 'GET',
      })
        })
    }

    async getWorkspaceCulture() {
        return await useAsyncData(() => {
            return super.call('/api/workplace-cultures', {
                method: 'GET',
            })
    })
    }

    async getMaleWorkerPercentages() {
        return await useAsyncData(() => {
            return super.call('/api/male-worker-percentages', {
                method: 'GET',
      })
        })
    }

    async getJapaneseUsageFrequencies() {
        return await useAsyncData(() => {
            return super.call('/api/japanese-usage-frequencies', {
                method: 'GET',
      })
        })
    }

    async getDayOffActivities() {
        return await useAsyncData('day-off-activities', async () => {
            return await super.call('/api/day-off-activities', {
                method: 'GET',
      })
        })
    }

    async getCharacterTypes() {
        return await useAsyncData('character-types', async () => {
            return await super.call('/api/character-types', {
                method: 'GET',
      })
        })
    }

    async getWorkingStyles() {
        return await useAsyncData('working-styles', async () => {
            return await super.call('/api/working-styles', {
                method: 'GET',
      })
        })
    }

    async getWorkEnvironments() {
        return await useAsyncData('work-environments', async () => {
            return await super.call('/api/work-environments', {
                method: 'GET',
      })
        })
    }

    async getSkillLevels() {
        return await useAsyncData('skill-levels', async () => {
            return await super.call('/api/skill-levels', {
                method: 'GET',
      })
        })
    }

    async getOtherSkillLevels() {
        return await useAsyncData('other-skill-levels', async () => {
            return await super.call('/api/other-skill-levels', {
                method: 'GET',
      })
        })
    }

    async getTemplateQuestions() {
        return await useAsyncData('template-questions', async () => {
            return await super.call('/api/template-questions', {
                method: 'GET',
      })
        })
    }

    async getPersonalityTraits(groupInput: string) {
        return await useAsyncData(`personality-traits-${groupInput}`, async () => {
            return await super.call('/api/personality-traits', {
                method: 'GET',
                query: { 'filter[group_input]': groupInput },
      })
        })
    }

    async getGenders() {
        return await useAsyncData('genders', async () => {
            return await super.call('/api/genders', {
                method: 'GET',
      })
        })
    }

    async getCity(payload: City) {
        return await useAsyncData(() => {
            const { query } = payload
            return super.call('/api/cities', {
                method: 'GET',
                query
            })
        })
    }

    async getSiteSetting() {
        return await useAsyncData(() => {
            return super.call('/api/site-settings', {
                method: 'GET',
            })
        })
    }
}

export default MasterModule
